import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Host,
  HostBinding,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  SkipSelf,
  TemplateRef,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { FormFieldComponent } from './form-field.component';


@Component({
  selector: 'form-control',
  template: `
      <ng-container *ngIf="_parent">
          <ng-container
                  renderControl
                  [name]="_parent.name"
                  [control]="_parent.control"
                  [root]="_parent.root"
                  [events]="{
                    change: onChanged,
                    blur: onBlurred,
                    enter: onEntered,
                    focus: onFocused
                   }"
                  [template]="template"
          >
          </ng-container>
      </ng-container>
  
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormControlComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  ///-----------------------------------------------  Variables   -----------------------------------------------///
  
  /**
   * @description
   * The parent  for the containers
   *
   * @internal
   */
  
  _parent: FormFieldComponent;
  
  template: TemplateRef<any> = null;
  
  @HostBinding('class.form-control') setClass = true;
  
  
  @Output() change = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Output() enter = new EventEmitter();
  @Output() focus = new EventEmitter();
  
  ///-----------------------------------------------  Life Cycle Hook   -----------------------------------------------///
  
  
  constructor(
    private cd: ChangeDetectorRef,
    private _vcRef: ViewContainerRef,
    @Optional() @Host() @SkipSelf() parent: FormFieldComponent
  ) {
    this._parent = parent;
    
  }
  
  ngOnInit(): void {
  
  
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    // this.cd.detectChanges();
  }
  
  ngAfterViewInit(): void {
  
  }
  
  ngOnDestroy(): void {
  }
  
  ///-----------------------------------------------  Main Functions   -----------------------------------------------///
  
  onChanged = e => {
    this._parent.control.setValue(e);
    this.change.emit(e);
    this.cd.markForCheck();
  };
  
  onBlurred = () => {
    this._parent.control.markAsBlurred();
    if (!this._parent.control.touched) {
      this._parent.control.markAsTouched();
    }
    this.blur.emit();
    this.cd.markForCheck();
  };
  
  onEntered = () => {
    // this.formSvs._onEntered()
    // if (this.name === 'password') this.focus = true;
  };
  
  onFocused = () => {
    this._parent.control.markAsFocused();
    this.focus.emit();
    this.cd.markForCheck();
  };
}
